export default __webpack_public_path__ + "static/media/linkedin.5cec2285.svg";